
export function init() {
    const lightbox = document.querySelector('.js-projects-lightbox'),
        lightboxName = document.querySelector('.js-projects-lightbox-name'),
        lightboxAbout = document.querySelector('.js-projects-lightbox-description'),
        lightboxLink = document.querySelector('.js-projects-lightbox-link');

    // Click handler to show lightbox for person/project details
    document.querySelectorAll('.js-project-lightbox').forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault();

            // Populate lightbox content
            lightboxName.textContent = el.dataset.name;
            lightboxAbout.textContent = el.dataset.about;
            lightboxLink.textContent = el.dataset.morelinkformatted;
            lightboxLink.href = el.dataset.morelinkhref;

            // Show/Hide lightbox link
            if (el.dataset.morelinkformatted){
                lightboxLink.style.display = 'inilne-block';
            } else {
                lightboxLink.style.display = 'none';
            }

            // Show lightbox
            lightbox.classList.add('visible');
        });
    });

    // Hide lightbox when clicking on lightbox overlay
    lightbox.addEventListener('click', e => {
        e.preventDefault();

        lightbox.classList.remove('visible');
    });

    // Prevent bubbling of internal anchor clicks triggering container close event
    lightbox.querySelectorAll('a').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.stopPropagation();
        });
    });
}